<template>
    <div v-if="in_modal" style="float:right; margin-right: 10px;">
      <v-btn
            style="margin-right: 5px"
            color="primary"
            text
            id="skip_button"
            @click="isSkipped"
          >
            {{$t('annotate.btns_skip')}}
          </v-btn>

      <v-btn
            style="margin-right: 5px"
            color="primary"
            text
            id="unclear_button"
            @click="isUnclear"
          >
            {{$t('annotate.btns_unclear')}}
          </v-btn>

      <v-btn
          style="margin-right: 5px"
          text
          color="primary"
          id="invalidate_button_modal"
          @click="isInvalid"
      >
        {{$t('annotate.btns_invalidate')}}
      </v-btn>

      <v-btn
            color="primary"
            text
            id="save_button"
             @click="isCorrect"
          >
           {{$t('annotate.btns_save')}} <v-icon
          dark
          primary
          right
        >
          fas fa-level-down-alt fa-rotate-90
        </v-icon>
          </v-btn>
  </div>
  <div v-else class="annotate-buttons">
     <v-btn
         class="annotate-buttons__btn"
            color="primary"
            id="skip_button"
            @click="isSkipped"
          >
            {{$t('annotate.btns_skip')}}
          </v-btn>

     <v-btn
         class="annotate-buttons__btn"
            color="primary"
            id="unclear_button"
            @click="isUnclear"
          >
            {{$t('annotate.btns_unclear')}}
          </v-btn>

      <v-btn
          class="annotate-buttons__btn"
          color="primary"
          id="invalidate_button"
          @click="isInvalid"
      >
        {{$t('annotate.btns_invalidate')}}
      </v-btn>

      <v-btn
            class="annotate-buttons__btn"
            color="primary"
            id="save_button"
             @click="isCorrect"
          >
           {{$t('annotate.btns_save')}} <v-icon
          dark
          primary
          right
        >
          fas fa-level-down-alt fa-rotate-90
        </v-icon>
          </v-btn>
        <a
          v-if="asset_id_history.length > 0"
          class="annotate-buttons__previous"
          href="#"
          @click.prevent="checkPrevious"
        >Check previous</a>
  </div>
</template>

<script>
export default {
  name: "AnnotateButtons",
  emits: ['stored', 'store_action', 'set_loading', 'check_previous', 'annotate-limit-reached'],
  props: {
    'asset_id_history': {required: true},
    'annotations': {required: true},
    'asset_id': {required: true},
    'in_modal': {default: false},
    'asset_in_validation_set': {default: null},
    /** When true, advance immediately and let the parent save in the background. */
    'instant_advance': {default: false},
  },
  mounted() {
    window.addEventListener('keydown', this.addEvents);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.addEvents);
  },
  methods: {
    setLoading(loading) {
      this.$emit('set_loading', loading);
    },
    checkPrevious() {
      if (this.asset_id_history.length === 0) {
        return;
      }
      this.$emit('check_previous', this.asset_id_history[this.asset_id_history.length - 1]);
    },
    addEvents: function(e) {
        let activeElement = document.activeElement;
        let inputs = ['input', 'select', 'button', 'textarea'];

        if (activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1) {
            return false;
        }

        if(e.keyCode === 13) { //enter
          e.stopPropagation();
          e.preventDefault();
          this.isCorrect();
        }
    },
    emitInstantAdvance(action) {
      this.$emit('store_action', {
        action,
        asset_id: this.asset_id,
        annotations: this.annotations,
        asset_in_validation_set: this.asset_in_validation_set,
      });
    },
    async isCorrect() {
      if (this.instant_advance) {
        this.emitInstantAdvance('save');
        return;
      }
      this.setLoading(true)
      let response = await this.$api.asset.save(this.asset_id, this.annotations, this.asset_in_validation_set)
      if (response && typeof response === 'object' && response.limit_reached && response.limit_type === 'ANNOTATION_LIMIT') {
        this.$emit("annotate-limit-reached");
        this.setLoading(false);
        return
      }
      this.setLoading(false);
      this.$emit('stored');
    },
    async isInvalid() {
      if (this.instant_advance) {
        this.emitInstantAdvance('invalid');
        return;
      }
      this.setLoading(true)
      await this.$api.asset.mark_invalidated([this.asset_id])
      this.setLoading(false);
      this.$emit('stored');
    },
    async isUnclear() {
      if (this.instant_advance) {
        this.emitInstantAdvance('unclear');
        return;
      }
      this.setLoading(true);
      await this.$api.asset.mark_unclear(this.asset_id);
      this.setLoading(false);
      this.$emit('stored');
    },
    async isSkipped() {
      if (this.instant_advance) {
        this.emitInstantAdvance('skipped');
        return;
      }
      this.setLoading(true);
      await this.$api.asset.mark_skipped(this.asset_id);
      this.setLoading(false);
      this.$emit('stored');
    },
  }
}
</script>

<style scoped>
.annotate-buttons {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  margin-top: 8px;
  max-width: 100%;
}

.annotate-buttons__btn {
  width: 100%;
  margin: 0;
}

.annotate-buttons__previous {
  flex: 0 0 100%;
  font-size: 13px;
}
</style>
